module.exports = __webpack_public_path__ + "img/40.271ccbff.jpg";